import type { DocTypeView, ViewStyleKey } from "@/lib/views/types";
import type { getDocViewSchema } from "@/lib/views/docViewSchemas";

/**
 * Create a synthetic DocTypeView for schema-only doctypes without a view registry entry.
 *
 * Shared by StandardDetailPage and GenericDetailContent (was duplicated in both).
 */
export function createSyntheticDocTypeView(
  doctype: string,
  schema: ReturnType<typeof getDocViewSchema>
): DocTypeView {
  // Determine style from schema (prefer experience variant, fallback to system)
  const experienceVariant = schema.views.experience;
  const createVariant = schema.views.create;
  const variantToUse = createVariant || experienceVariant;

  // Extract style from variant (default to 'shopify' if not specified)
  // style is optional in DocViewVariantConfig, so we need to handle undefined
  const style = (variantToUse?.style || 'shopify') as ViewStyleKey;

  return {
    id: `schema-${doctype.toLowerCase().replace(/\s+/g, "-")}-v1`,
    doctype,
    style,
    status: 'active',
    label: `${doctype} Schema View`,
    formView: {
      sections: [], // Empty - schema will override via convertSchemaToTabs
    },
    createdBy: 'system',
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString(),
  };
}
